import {getUserTimeZone} from 'Utils';

const TZCITY_TO_COUNTRYCODE = {
  'Andorra': 'AD',
  'Dubai': 'AE',
  'Kabul': 'AF',
  'Tirane': 'AL',
  'Yerevan': 'AM',
  'Casey': 'AQ',
  'Davis': 'AQ',
  'Mawson': 'AQ',
  'Palmer': 'AQ',
  'Rothera': 'AQ',
  'Troll': 'AQ',
  'Buenos_Aires': 'AR',
  'Cordoba': 'AR',
  'Salta': 'AR',
  'Jujuy': 'AR',
  'Tucuman': 'AR',
  'Catamarca': 'AR',
  'La_Rioja': 'AR',
  'San_Juan': 'AR',
  'Mendoza': 'AR',
  'San_Luis': 'AR',
  'Rio_Gallegos': 'AR',
  'Ushuaia': 'AR',
  'Pago_Pago': 'AS',
  'Vienna': 'AT',
  'Lord_Howe': 'AU',
  'Macquarie': 'AU',
  'Hobart': 'AU',
  'Melbourne': 'AU',
  'Sydney': 'AU',
  'Broken_Hill': 'AU',
  'Brisbane': 'AU',
  'Lindeman': 'AU',
  'Adelaide': 'AU',
  'Darwin': 'AU',
  'Perth': 'AU',
  'Eucla': 'AU',
  'Baku': 'AZ',
  'Barbados': 'BB',
  'Dhaka': 'BD',
  'Brussels': 'BE',
  'Sofia': 'BG',
  'Bermuda': 'BM',
  'La_Paz': 'BO',
  'Noronha': 'BR',
  'Belem': 'BR',
  'Fortaleza': 'BR',
  'Recife': 'BR',
  'Araguaina': 'BR',
  'Maceio': 'BR',
  'Bahia': 'BR',
  'Sao_Paulo': 'BR',
  'Campo_Grande': 'BR',
  'Cuiaba': 'BR',
  'Santarem': 'BR',
  'Porto_Velho': 'BR',
  'Boa_Vista': 'BR',
  'Manaus': 'BR',
  'Eirunepe': 'BR',
  'Rio_Branco': 'BR',
  'Thimphu': 'BT',
  'Minsk': 'BY',
  'Belize': 'BZ',
  'St_Johns': 'CA',
  'Halifax': 'CA',
  'Glace_Bay': 'CA',
  'Moncton': 'CA',
  'Goose_Bay': 'CA',
  'Toronto': 'CA',
  'Iqaluit': 'CA',
  'Winnipeg': 'CA',
  'Resolute': 'CA',
  'Rankin_Inlet': 'CA',
  'Regina': 'CA',
  'Swift_Current': 'CA',
  'Edmonton': 'CA',
  'Cambridge_Bay': 'CA',
  'Yellowknife': 'CA',
  'Inuvik': 'CA',
  'Dawson_Creek': 'CA',
  'Fort_Nelson': 'CA',
  'Whitehorse': 'CA',
  'Dawson': 'CA',
  'Vancouver': 'CA',
  'Zurich': 'CH',
  'Abidjan': 'CI',
  'Rarotonga': 'CK',
  'Santiago': 'CL',
  'Punta_Arenas': 'CL',
  'Easter': 'CL',
  'Shanghai': 'CN',
  'Urumqi': 'CN',
  'Bogota': 'CO',
  'Costa_Rica': 'CR',
  'Havana': 'CU',
  'Cape_Verde': 'CV',
  'Nicosia': 'CY',
  'Famagusta': 'CY',
  'Prague': 'CZ',
  'Berlin': 'DE',
  'Santo_Domingo': 'DO',
  'Algiers': 'DZ',
  'Guayaquil': 'EC',
  'Galapagos': 'EC',
  'Tallinn': 'EE',
  'Cairo': 'EG',
  'El_Aaiun': 'EH',
  'Madrid': 'ES',
  'Ceuta': 'ES',
  'Canary': 'ES',
  'Helsinki': 'FI',
  'Fiji': 'FJ',
  'Stanley': 'FK',
  'Kosrae': 'FM',
  'Faroe': 'FO',
  'Paris': 'FR',
  'London': 'GB',
  'Tbilisi': 'GE',
  'Cayenne': 'GF',
  'Gibraltar': 'GI',
  'Nuuk': 'GL',
  'Danmarkshavn': 'GL',
  'Scoresbysund': 'GL',
  'Thule': 'GL',
  'Athens': 'GR',
  'South_Georgia': 'GS',
  'Guatemala': 'GT',
  'Guam': 'GU',
  'Bissau': 'GW',
  'Guyana': 'GY',
  'Hong_Kong': 'HK',
  'Tegucigalpa': 'HN',
  'Port-au-Prince': 'HT',
  'Budapest': 'HU',
  'Jakarta': 'ID',
  'Pontianak': 'ID',
  'Makassar': 'ID',
  'Jayapura': 'ID',
  'Dublin': 'IE',
  'Jerusalem': 'IL',
  'Kolkata': 'IN',
  'Chagos': 'IO',
  'Baghdad': 'IQ',
  'Tehran': 'IR',
  'Rome': 'IT',
  'Jamaica': 'JM',
  'Amman': 'JO',
  'Tokyo': 'JP',
  'Nairobi': 'KE',
  'Bishkek': 'KG',
  'Tarawa': 'KI',
  'Kanton': 'KI',
  'Kiritimati': 'KI',
  'Pyongyang': 'KP',
  'Seoul': 'KR',
  'Almaty': 'KZ',
  'Qyzylorda': 'KZ',
  'Qostanay': 'KZ',
  'Aqtobe': 'KZ',
  'Aqtau': 'KZ',
  'Atyrau': 'KZ',
  'Oral': 'KZ',
  'Beirut': 'LB',
  'Colombo': 'LK',
  'Monrovia': 'LR',
  'Vilnius': 'LT',
  'Riga': 'LV',
  'Tripoli': 'LY',
  'Casablanca': 'MA',
  'Chisinau': 'MD',
  'Kwajalein': 'MH',
  'Yangon': 'MM',
  'Ulaanbaatar': 'MN',
  'Hovd': 'MN',
  'Choibalsan': 'MN',
  'Macau': 'MO',
  'Martinique': 'MQ',
  'Malta': 'MT',
  'Mauritius': 'MU',
  'Maldives': 'MV',
  'Mexico_City': 'MX',
  'Cancun': 'MX',
  'Merida': 'MX',
  'Monterrey': 'MX',
  'Matamoros': 'MX',
  'Chihuahua': 'MX',
  'Ciudad_Juarez': 'MX',
  'Ojinaga': 'MX',
  'Mazatlan': 'MX',
  'Bahia_Banderas': 'MX',
  'Hermosillo': 'MX',
  'Tijuana': 'MX',
  'Kuching': 'MY',
  'Maputo': 'MZ',
  'Windhoek': 'NA',
  'Noumea': 'NC',
  'Norfolk': 'NF',
  'Lagos': 'NG',
  'Managua': 'NI',
  'Kathmandu': 'NP',
  'Nauru': 'NR',
  'Niue': 'NU',
  'Auckland': 'NZ',
  'Chatham': 'NZ',
  'Panama': 'PA',
  'Lima': 'PE',
  'Tahiti': 'PF',
  'Marquesas': 'PF',
  'Gambier': 'PF',
  'Port_Moresby': 'PG',
  'Bougainville': 'PG',
  'Manila': 'PH',
  'Karachi': 'PK',
  'Warsaw': 'PL',
  'Miquelon': 'PM',
  'Pitcairn': 'PN',
  'Puerto_Rico': 'PR',
  'Gaza': 'PS',
  'Hebron': 'PS',
  'Lisbon': 'PT',
  'Madeira': 'PT',
  'Azores': 'PT',
  'Palau': 'PW',
  'Asuncion': 'PY',
  'Qatar': 'QA',
  'Bucharest': 'RO',
  'Belgrade': 'RS',
  'Kaliningrad': 'RU',
  'Moscow': 'RU',
  'Simferopol': 'RU',
  'Kirov': 'RU',
  'Volgograd': 'RU',
  'Astrakhan': 'RU',
  'Saratov': 'RU',
  'Ulyanovsk': 'RU',
  'Samara': 'RU',
  'Yekaterinburg': 'RU',
  'Omsk': 'RU',
  'Novosibirsk': 'RU',
  'Barnaul': 'RU',
  'Tomsk': 'RU',
  'Novokuznetsk': 'RU',
  'Krasnoyarsk': 'RU',
  'Irkutsk': 'RU',
  'Chita': 'RU',
  'Yakutsk': 'RU',
  'Khandyga': 'RU',
  'Vladivostok': 'RU',
  'Ust-Nera': 'RU',
  'Magadan': 'RU',
  'Sakhalin': 'RU',
  'Srednekolymsk': 'RU',
  'Kamchatka': 'RU',
  'Anadyr': 'RU',
  'Riyadh': 'SA',
  'Guadalcanal': 'SB',
  'Khartoum': 'SD',
  'Singapore': 'SG',
  'Paramaribo': 'SR',
  'Juba': 'SS',
  'Sao_Tome': 'ST',
  'El_Salvador': 'SV',
  'Damascus': 'SY',
  'Grand_Turk': 'TC',
  'Ndjamena': 'TD',
  'Bangkok': 'TH',
  'Dushanbe': 'TJ',
  'Fakaofo': 'TK',
  'Dili': 'TL',
  'Ashgabat': 'TM',
  'Tunis': 'TN',
  'Tongatapu': 'TO',
  'Istanbul': 'TR',
  'Taipei': 'TW',
  'Kyiv': 'UA',
  'New_York': 'US',
  'Detroit': 'US',
  'Louisville': 'US',
  'Monticello': 'US',
  'Indianapolis': 'US',
  'Vincennes': 'US',
  'Winamac': 'US',
  'Marengo': 'US',
  'Petersburg': 'US',
  'Vevay': 'US',
  'Chicago': 'US',
  'Tell_City': 'US',
  'Knox': 'US',
  'Menominee': 'US',
  'Center': 'US',
  'New_Salem': 'US',
  'Beulah': 'US',
  'Denver': 'US',
  'Boise': 'US',
  'Phoenix': 'US',
  'Los_Angeles': 'US',
  'Anchorage': 'US',
  'Juneau': 'US',
  'Sitka': 'US',
  'Metlakatla': 'US',
  'Yakutat': 'US',
  'Nome': 'US',
  'Adak': 'US',
  'Honolulu': 'US',
  'Montevideo': 'UY',
  'Samarkand': 'UZ',
  'Tashkent': 'UZ',
  'Caracas': 'VE',
  'Ho_Chi_Minh': 'VN',
  'Efate': 'VU',
  'Apia': 'WS',
  'Johannesburg': 'ZA',
  'Antigua': 'AG',
  'Anguilla': 'AI',
  'Luanda': 'AO',
  'McMurdo': 'AQ',
  'DumontDUrville': 'AQ',
  'Syowa': 'AQ',
  'Vostok': 'AQ',
  'Aruba': 'AW',
  'Mariehamn': 'AX',
  'Sarajevo': 'BA',
  'Ouagadougou': 'BF',
  'Bahrain': 'BH',
  'Bujumbura': 'BI',
  'Porto-Novo': 'BJ',
  'St_Barthelemy': 'BL',
  'Brunei': 'BN',
  'Kralendijk': 'BQ',
  'Nassau': 'BS',
  'Gaborone': 'BW',
  'Blanc-Sablon': 'CA',
  'Atikokan': 'CA',
  'Creston': 'CA',
  'Cocos': 'CC',
  'Kinshasa': 'CD',
  'Lubumbashi': 'CD',
  'Bangui': 'CF',
  'Brazzaville': 'CG',
  'Douala': 'CM',
  'Curacao': 'CW',
  'Christmas': 'CX',
  'Busingen': 'DE',
  'Djibouti': 'DJ',
  'Copenhagen': 'DK',
  'Dominica': 'DM',
  'Asmara': 'ER',
  'Addis_Ababa': 'ET',
  'Chuuk': 'FM',
  'Pohnpei': 'FM',
  'Libreville': 'GA',
  'Grenada': 'GD',
  'Guernsey': 'GG',
  'Accra': 'GH',
  'Banjul': 'GM',
  'Conakry': 'GN',
  'Guadeloupe': 'GP',
  'Malabo': 'GQ',
  'Zagreb': 'HR',
  'Isle_of_Man': 'IM',
  'Reykjavik': 'IS',
  'Jersey': 'JE',
  'Phnom_Penh': 'KH',
  'Comoro': 'KM',
  'St_Kitts': 'KN',
  'Kuwait': 'KW',
  'Cayman': 'KY',
  'Vientiane': 'LA',
  'St_Lucia': 'LC',
  'Vaduz': 'LI',
  'Maseru': 'LS',
  'Luxembourg': 'LU',
  'Monaco': 'MC',
  'Podgorica': 'ME',
  'Marigot': 'MF',
  'Antananarivo': 'MG',
  'Majuro': 'MH',
  'Skopje': 'MK',
  'Bamako': 'ML',
  'Saipan': 'MP',
  'Nouakchott': 'MR',
  'Montserrat': 'MS',
  'Blantyre': 'MW',
  'Kuala_Lumpur': 'MY',
  'Niamey': 'NE',
  'Amsterdam': 'NL',
  'Oslo': 'NO',
  'Muscat': 'OM',
  'Reunion': 'RE',
  'Kigali': 'RW',
  'Mahe': 'SC',
  'Stockholm': 'SE',
  'St_Helena': 'SH',
  'Ljubljana': 'SI',
  'Longyearbyen': 'SJ',
  'Bratislava': 'SK',
  'Freetown': 'SL',
  'San_Marino': 'SM',
  'Dakar': 'SN',
  'Mogadishu': 'SO',
  'Lower_Princes': 'SX',
  'Mbabane': 'SZ',
  'Kerguelen': 'TF',
  'Lome': 'TG',
  'Port_of_Spain': 'TT',
  'Funafuti': 'TV',
  'Dar_es_Salaam': 'TZ',
  'Kampala': 'UG',
  'Midway': 'UM',
  'Wake': 'UM',
  'Vatican': 'VA',
  'St_Vincent': 'VC',
  'Tortola': 'VG',
  'St_Thomas': 'VI',
  'Wallis': 'WF',
  'Aden': 'YE',
  'Mayotte': 'YT',
  'Lusaka': 'ZM',
  'Harare': 'ZW',
};

const PHONE_COUNTRY_CODES = {
  'AF': '+93',
  'AX': '+358',
  'AL': '+355',
  'DZ': '+213',
  'AS': '+1684',
  'AD': '+376',
  'AO': '+244',
  'AI': '+1264',
  'AQ': '+672',
  'AG': '+1268',
  'AR': '+54',
  'AM': '+374',
  'AW': '+297',
  'AU': '+61',
  'AT': '+43',
  'AZ': '+994',
  'BS': '+1242',
  'BH': '+973',
  'BD': '+880',
  'BB': '+1246',
  'BY': '+375',
  'BE': '+32',
  'BZ': '+501',
  'BJ': '+229',
  'BM': '+1441',
  'BT': '+975',
  'BO': '+591',
  'BA': '+387',
  'BW': '+267',
  'BR': '+55',
  'IO': '+246',
  'BN': '+673',
  'BG': '+359',
  'BF': '+226',
  'BI': '+257',
  'KH': '+855',
  'CM': '+237',
  'CA': '+1',
  'CV': '+238',
  'KY': '+345',
  'CF': '+236',
  'TD': '+235',
  'CL': '+56',
  'CN': '+86',
  'CX': '+61',
  'CC': '+61',
  'CO': '+57',
  'KM': '+269',
  'CG': '+242',
  'CD': '+243',
  'CK': '+682',
  'CR': '+506',
  'CI': '+225',
  'HR': '+385',
  'CU': '+53',
  'CY': '+357',
  'CZ': '+420',
  'DK': '+45',
  'DJ': '+253',
  'DM': '+1767',
  'DO': '+1849',
  'EC': '+593',
  'EG': '+20',
  'SV': '+503',
  'GQ': '+240',
  'ER': '+291',
  'EE': '+372',
  'ET': '+251',
  'FK': '+500',
  'FO': '+298',
  'FJ': '+679',
  'FI': '+358',
  'FR': '+33',
  'GF': '+594',
  'PF': '+689',
  'GA': '+241',
  'GM': '+220',
  'GE': '+995',
  'DE': '+49',
  'GH': '+233',
  'GI': '+350',
  'GR': '+30',
  'GL': '+299',
  'GD': '+1473',
  'GP': '+590',
  'GU': '+1671',
  'GT': '+502',
  'GG': '+44',
  'GN': '+224',
  'GW': '+245',
  'GY': '+595',
  'HT': '+509',
  'VA': '+379',
  'HN': '+504',
  'HK': '+852',
  'HU': '+36',
  'IS': '+354',
  'IN': '+91',
  'ID': '+62',
  'IR': '+98',
  'IQ': '+964',
  'IE': '+353',
  'IM': '+44',
  'IL': '+972',
  'IT': '+39',
  'JM': '+1876',
  'JP': '+81',
  'JE': '+44',
  'JO': '+962',
  'KZ': '+77',
  'KE': '+254',
  'KI': '+686',
  'KP': '+850',
  'KR': '+82',
  'KW': '+965',
  'KG': '+996',
  'LA': '+856',
  'LV': '+371',
  'LB': '+961',
  'LS': '+266',
  'LR': '+231',
  'LY': '+218',
  'LI': '+423',
  'LT': '+370',
  'LU': '+352',
  'MO': '+853',
  'MK': '+389',
  'MG': '+261',
  'MW': '+265',
  'MY': '+60',
  'MV': '+960',
  'ML': '+223',
  'MT': '+356',
  'MH': '+692',
  'MQ': '+596',
  'MR': '+222',
  'MU': '+230',
  'YT': '+262',
  'MX': '+52',
  'FM': '+691',
  'MD': '+373',
  'MC': '+377',
  'MN': '+976',
  'ME': '+382',
  'MS': '+1664',
  'MA': '+212',
  'MZ': '+258',
  'MM': '+95',
  'NA': '+264',
  'NR': '+674',
  'NP': '+977',
  'NL': '+31',
  'AN': '+599',
  'NC': '+687',
  'NZ': '+64',
  'NI': '+505',
  'NE': '+227',
  'NG': '+234',
  'NU': '+683',
  'NF': '+672',
  'MP': '+1670',
  'NO': '+47',
  'OM': '+968',
  'PK': '+92',
  'PW': '+680',
  'PS': '+970',
  'PA': '+507',
  'PG': '+675',
  'PY': '+595',
  'PE': '+51',
  'PH': '+63',
  'PN': '+872',
  'PL': '+48',
  'PT': '+351',
  'PR': '+1939',
  'QA': '+974',
  'RO': '+40',
  'RU': '+7',
  'RW': '+250',
  'RE': '+262',
  'BL': '+590',
  'SH': '+290',
  'KN': '+1869',
  'LC': '+1758',
  'MF': '+590',
  'PM': '+508',
  'VC': '+1784',
  'WS': '+685',
  'SM': '+378',
  'ST': '+239',
  'SA': '+966',
  'SN': '+221',
  'RS': '+381',
  'SC': '+248',
  'SL': '+232',
  'SG': '+65',
  'SK': '+421',
  'SI': '+386',
  'SB': '+677',
  'SO': '+252',
  'ZA': '+27',
  'SS': '+211',
  'GS': '+500',
  'ES': '+34',
  'LK': '+94',
  'SD': '+249',
  'SR': '+597',
  'SJ': '+47',
  'SZ': '+268',
  'SE': '+46',
  'CH': '+41',
  'SY': '+963',
  'TW': '+886',
  'TJ': '+992',
  'TZ': '+255',
  'TH': '+66',
  'TL': '+670',
  'TG': '+228',
  'TK': '+690',
  'TO': '+676',
  'TT': '+1868',
  'TN': '+216',
  'TR': '+90',
  'TM': '+993',
  'TC': '+1649',
  'TV': '+688',
  'UG': '+256',
  'UA': '+380',
  'AE': '+971',
  'GB': '+44',
  'US': '+1',
  'UY': '+598',
  'UZ': '+998',
  'VU': '+678',
  'VE': '+58',
  'VN': '+84',
  'VG': '+1284',
  'VI': '+1340',
  'WF': '+681',
  'YE': '+967',
  'ZM': '+260',
  'ZW': '+263',
};

// eslint-disable-next-line max-len
// From https://bitbucket.org/atlassian/atlaskit-mk-2/raw/4ad0e56649c3e6c973e226b7efaeb28cb240ccb0/packages/core/select/src/data/countries.js
export const COUNTRY_DATA = [
  {code: 'AD', label: 'Andorra', phone: '+376'},
  {
    code: 'AE',
    label: 'United Arab Emirates',
    phone: '+971',
  },
  {code: 'AF', label: 'Afghanistan', phone: '+93'},
  {
    code: 'AG',
    label: 'Antigua and Barbuda',
    phone: '+1-268',
  },
  {code: 'AI', label: 'Anguilla', phone: '+1-264'},
  {code: 'AL', label: 'Albania', phone: '+355'},
  {code: 'AM', label: 'Armenia', phone: '+374'},
  {code: 'AO', label: 'Angola', phone: '+244'},
  {code: 'AQ', label: 'Antarctica', phone: '+672'},
  {code: 'AR', label: 'Argentina', phone: '+54'},
  {code: 'AS', label: 'American Samoa', phone: '+1-684'},
  {code: 'AT', label: 'Austria', phone: '+43'},
  {
    code: 'AU',
    label: 'Australia',
    phone: '+61',
    suggested: true,
  },
  {code: 'AW', label: 'Aruba', phone: '+297'},
  {code: 'AX', label: 'Alland Islands', phone: '+358'},
  {code: 'AZ', label: 'Azerbaijan', phone: '+994'},
  {
    code: 'BA',
    label: 'Bosnia and Herzegovina',
    phone: '+387',
  },
  {code: 'BB', label: 'Barbados', phone: '+1-246'},
  {code: 'BD', label: 'Bangladesh', phone: '+880'},
  {code: 'BE', label: 'Belgium', phone: '+32'},
  {code: 'BF', label: 'Burkina Faso', phone: '+226'},
  {code: 'BG', label: 'Bulgaria', phone: '+359'},
  {code: 'BH', label: 'Bahrain', phone: '+973'},
  {code: 'BI', label: 'Burundi', phone: '+257'},
  {code: 'BJ', label: 'Benin', phone: '+229'},
  {code: 'BL', label: 'Saint Barthelemy', phone: '+590'},
  {code: 'BM', label: 'Bermuda', phone: '+1-441'},
  {code: 'BN', label: 'Brunei Darussalam', phone: '+673'},
  {code: 'BO', label: 'Bolivia', phone: '+591'},
  {code: 'BR', label: 'Brazil', phone: '+55'},
  {code: 'BS', label: 'Bahamas', phone: '+1-242'},
  {code: 'BT', label: 'Bhutan', phone: '+975'},
  {code: 'BV', label: 'Bouvet Island', phone: '+47'},
  {code: 'BW', label: 'Botswana', phone: '+267'},
  {code: 'BY', label: 'Belarus', phone: '+375'},
  {code: 'BZ', label: 'Belize', phone: '+501'},
  {
    code: 'CA / USA',
    label: 'Canada / United States',
    phone: '+1',
    suggested: true,
  },
  {
    code: 'CC',
    label: 'Cocos (Keeling) Islands',
    phone: '+61',
  },
  {
    code: 'CD',
    label: 'Congo, Democratic Republic of the',
    phone: '+243',
  },
  {
    code: 'CF',
    label: 'Central African Republic',
    phone: '+236',
  },
  {
    code: 'CG',
    label: 'Congo, Republic of the',
    phone: '+242',
  },
  {code: 'CH', label: 'Switzerland', phone: '+41'},
  {code: 'CI', label: 'Cote d\'Ivoire', phone: '+225'},
  {code: 'CK', label: 'Cook Islands', phone: '+682'},
  {code: 'CL', label: 'Chile', phone: '+56'},
  {code: 'CM', label: 'Cameroon', phone: '+237'},
  {code: 'CN', label: 'China', phone: '+86'},
  {code: 'CO', label: 'Colombia', phone: '+57'},
  {code: 'CR', label: 'Costa Rica', phone: '+506'},
  {code: 'CU', label: 'Cuba', phone: '+53'},
  {code: 'CV', label: 'Cape Verde', phone: '+238'},
  {code: 'CW', label: 'Curacao', phone: '+599'},
  {code: 'CX', label: 'Christmas Island', phone: '+61'},
  {code: 'CY', label: 'Cyprus', phone: '+357'},
  {code: 'CZ', label: 'Czech Republic', phone: '+420'},
  {
    code: 'DE',
    label: 'Germany',
    phone: '+49',
    suggested: true,
  },
  {code: 'DJ', label: 'Djibouti', phone: '+253'},
  {code: 'DK', label: 'Denmark', phone: '+45'},
  {code: 'DM', label: 'Dominica', phone: '+1-767'},
  {
    code: 'DO',
    label: 'Dominican Republic',
    phone: '+1-809',
  },
  {code: 'DZ', label: 'Algeria', phone: '+213'},
  {code: 'EC', label: 'Ecuador', phone: '+593'},
  {code: 'EE', label: 'Estonia', phone: '+372'},
  {code: 'EG', label: 'Egypt', phone: '+20'},
  {code: 'EH', label: 'Western Sahara', phone: '+212'},
  {code: 'ER', label: 'Eritrea', phone: '+291'},
  {code: 'ES', label: 'Spain', phone: '+34'},
  {code: 'ET', label: 'Ethiopia', phone: '+251'},
  {code: 'FI', label: 'Finland', phone: '+358'},
  {code: 'FJ', label: 'Fiji', phone: '+679'},
  {
    code: 'FK',
    label: 'Falkland Islands (Malvinas)',
    phone: '+500',
  },
  {
    code: 'FM',
    label: 'Micronesia, Federated States of',
    phone: '+691',
  },
  {code: 'FO', label: 'Faroe Islands', phone: '+298'},
  {
    code: 'FR',
    label: 'France',
    phone: '+33',
    suggested: true,
  },
  {code: 'GA', label: 'Gabon', phone: '+241'},
  {code: 'GB', label: 'United Kingdom', phone: '+44'},
  {code: 'GD', label: 'Grenada', phone: '+1-473'},
  {code: 'GE', label: 'Georgia', phone: '+995'},
  {code: 'GF', label: 'French Guiana', phone: '+594'},
  {code: 'GG', label: 'Guernsey', phone: '+44'},
  {code: 'GH', label: 'Ghana', phone: '+233'},
  {code: 'GI', label: 'Gibraltar', phone: '+350'},
  {code: 'GL', label: 'Greenland', phone: '+299'},
  {code: 'GM', label: 'Gambia', phone: '+220'},
  {code: 'GN', label: 'Guinea', phone: '+224'},
  {code: 'GP', label: 'Guadeloupe', phone: '+590'},
  {code: 'GQ', label: 'Equatorial Guinea', phone: '+240'},
  {code: 'GR', label: 'Greece', phone: '+30'},
  {
    code: 'GS',
    label: 'South Georgia and the South Sandwich Islands',
    phone: '+500',
  },
  {code: 'GT', label: 'Guatemala', phone: '+502'},
  {code: 'GU', label: 'Guam', phone: '+1-671'},
  {code: 'GW', label: 'Guinea-Bissau', phone: '+245'},
  {code: 'GY', label: 'Guyana', phone: '+592'},
  {code: 'HK', label: 'Hong Kong', phone: '+852'},
  {
    code: 'HM',
    label: 'Heard Island and McDonald Islands',
    phone: '+672',
  },
  {code: 'HN', label: 'Honduras', phone: '+504'},
  {code: 'HR', label: 'Croatia', phone: '+385'},
  {code: 'HT', label: 'Haiti', phone: '+509'},
  {code: 'HU', label: 'Hungary', phone: '+36'},
  {code: 'ID', label: 'Indonesia', phone: '+62'},
  {code: 'IE', label: 'Ireland', phone: '+353'},
  {code: 'IL', label: 'Israel', phone: '+972'},
  {code: 'IM', label: 'Isle of Man', phone: '+44'},
  {code: 'IN', label: 'India', phone: '+91'},
  {
    code: 'IO',
    label: 'British Indian Ocean Territory',
    phone: '+246',
  },
  {code: 'IQ', label: 'Iraq', phone: '+964'},
  {
    code: 'IR',
    label: 'Iran, Islamic Republic of',
    phone: '+98',
  },
  {code: 'IS', label: 'Iceland', phone: '+354'},
  {code: 'IT', label: 'Italy', phone: '+39'},
  {code: 'JE', label: 'Jersey', phone: '+44'},
  {code: 'JM', label: 'Jamaica', phone: '+1-876'},
  {code: 'JO', label: 'Jordan', phone: '+962'},
  {
    code: 'JP',
    label: 'Japan',
    phone: '+81',
    suggested: true,
  },
  {code: 'KE', label: 'Kenya', phone: '+254'},
  {code: 'KG', label: 'Kyrgyzstan', phone: '+996'},
  {code: 'KH', label: 'Cambodia', phone: '+855'},
  {code: 'KI', label: 'Kiribati', phone: '+686'},
  {code: 'KM', label: 'Comoros', phone: '+269'},
  {
    code: 'KN',
    label: 'Saint Kitts and Nevis',
    phone: '+1-869',
  },
  {
    code: 'KP',
    label: 'Korea, Democratic People\'s Republic of',
    phone: '+850',
  },
  {code: 'KR', label: 'Korea, Republic of', phone: '+82'},
  {code: 'KW', label: 'Kuwait', phone: '+965'},
  {code: 'KY', label: 'Cayman Islands', phone: '+1-345'},
  {code: 'KZ', label: 'Kazakhstan', phone: '+7'},
  {
    code: 'LA',
    label: 'Lao People\'s Democratic Republic',
    phone: '+856',
  },
  {code: 'LB', label: 'Lebanon', phone: '+961'},
  {code: 'LC', label: 'Saint Lucia', phone: '+1-758'},
  {code: 'LI', label: 'Liechtenstein', phone: '+423'},
  {code: 'LK', label: 'Sri Lanka', phone: '+94'},
  {code: 'LR', label: 'Liberia', phone: '+231'},
  {code: 'LS', label: 'Lesotho', phone: '+266'},
  {code: 'LT', label: 'Lithuania', phone: '+370'},
  {code: 'LU', label: 'Luxembourg', phone: '+352'},
  {code: 'LV', label: 'Latvia', phone: '+371'},
  {code: 'LY', label: 'Libya', phone: '+218'},
  {code: 'MA', label: 'Morocco', phone: '+212'},
  {code: 'MC', label: 'Monaco', phone: '+377'},
  {
    code: 'MD',
    label: 'Moldova, Republic of',
    phone: '+373',
  },
  {code: 'ME', label: 'Montenegro', phone: '+382'},
  {
    code: 'MF',
    label: 'Saint Martin (French part)',
    phone: '+590',
  },
  {code: 'MG', label: 'Madagascar', phone: '+261'},
  {code: 'MH', label: 'Marshall Islands', phone: '+692'},
  {
    code: 'MK',
    label: 'Macedonia, the Former Yugoslav Republic of',
    phone: '+389',
  },
  {code: 'ML', label: 'Mali', phone: '+223'},
  {code: 'MM', label: 'Myanmar', phone: '+95'},
  {code: 'MN', label: 'Mongolia', phone: '+976'},
  {code: 'MO', label: 'Macao', phone: '+853'},
  {
    code: 'MP',
    label: 'Northern Mariana Islands',
    phone: '+1-670',
  },
  {code: 'MQ', label: 'Martinique', phone: '+596'},
  {code: 'MR', label: 'Mauritania', phone: '+222'},
  {code: 'MS', label: 'Montserrat', phone: '+1-664'},
  {code: 'MT', label: 'Malta', phone: '+356'},
  {code: 'MU', label: 'Mauritius', phone: '+230'},
  {code: 'MV', label: 'Maldives', phone: '+960'},
  {code: 'MW', label: 'Malawi', phone: '+265'},
  {code: 'MX', label: 'Mexico', phone: '+52'},
  {code: 'MY', label: 'Malaysia', phone: '+60'},
  {code: 'MZ', label: 'Mozambique', phone: '+258'},
  {code: 'NA', label: 'Namibia', phone: '+264'},
  {code: 'NC', label: 'New Caledonia', phone: '+687'},
  {code: 'NE', label: 'Niger', phone: '+227'},
  {code: 'NF', label: 'Norfolk Island', phone: '+672'},
  {code: 'NG', label: 'Nigeria', phone: '+234'},
  {code: 'NI', label: 'Nicaragua', phone: '+505'},
  {code: 'NL', label: 'Netherlands', phone: '+31'},
  {code: 'NO', label: 'Norway', phone: '+47'},
  {code: 'NP', label: 'Nepal', phone: '+977'},
  {code: 'NR', label: 'Nauru', phone: '+674'},
  {code: 'NU', label: 'Niue', phone: '+683'},
  {code: 'NZ', label: 'New Zealand', phone: '+64'},
  {code: 'OM', label: 'Oman', phone: '+968'},
  {code: 'PA', label: 'Panama', phone: '+507'},
  {code: 'PE', label: 'Peru', phone: '+51'},
  {code: 'PF', label: 'French Polynesia', phone: '+689'},
  {code: 'PG', label: 'Papua New Guinea', phone: '+675'},
  {code: 'PH', label: 'Philippines', phone: '+63'},
  {code: 'PK', label: 'Pakistan', phone: '+92'},
  {code: 'PL', label: 'Poland', phone: '+48'},
  {
    code: 'PM',
    label: 'Saint Pierre and Miquelon',
    phone: '+508',
  },
  {code: 'PN', label: 'Pitcairn', phone: '+870'},
  {code: 'PR', label: 'Puerto Rico', phone: '+1'},
  {
    code: 'PS',
    label: 'Palestine, State of',
    phone: '+970',
  },
  {code: 'PT', label: 'Portugal', phone: '+351'},
  {code: 'PW', label: 'Palau', phone: '+680'},
  {code: 'PY', label: 'Paraguay', phone: '+595'},
  {code: 'QA', label: 'Qatar', phone: '+974'},
  {code: 'RE', label: 'Reunion', phone: '+262'},
  {code: 'RO', label: 'Romania', phone: '+40'},
  {code: 'RS', label: 'Serbia', phone: '+381'},
  {code: 'RU', label: 'Russian Federation', phone: '+7'},
  {code: 'RW', label: 'Rwanda', phone: '+250'},
  {code: 'SA', label: 'Saudi Arabia', phone: '+966'},
  {code: 'SB', label: 'Solomon Islands', phone: '+677'},
  {code: 'SC', label: 'Seychelles', phone: '+248'},
  {code: 'SD', label: 'Sudan', phone: '+249'},
  {code: 'SE', label: 'Sweden', phone: '+46'},
  {code: 'SG', label: 'Singapore', phone: '+65'},
  {code: 'SH', label: 'Saint Helena', phone: '+290'},
  {code: 'SI', label: 'Slovenia', phone: '+386'},
  {
    code: 'SJ',
    label: 'Svalbard and Jan Mayen',
    phone: '+47',
  },
  {code: 'SK', label: 'Slovakia', phone: '+421'},
  {code: 'SL', label: 'Sierra Leone', phone: '+232'},
  {code: 'SM', label: 'San Marino', phone: '+378'},
  {code: 'SN', label: 'Senegal', phone: '+221'},
  {code: 'SO', label: 'Somalia', phone: '+252'},
  {code: 'SR', label: 'Suriname', phone: '+597'},
  {code: 'SS', label: 'South Sudan', phone: '+211'},
  {
    code: 'ST',
    label: 'Sao Tome and Principe',
    phone: '+239',
  },
  {code: 'SV', label: 'El Salvador', phone: '+503'},
  {
    code: 'SX',
    label: 'Sint Maarten (Dutch part)',
    phone: '+1-721',
  },
  {
    code: 'SY',
    label: 'Syrian Arab Republic',
    phone: '+963',
  },
  {code: 'SZ', label: 'Swaziland', phone: '+268'},
  {
    code: 'TC',
    label: 'Turks and Caicos Islands',
    phone: '+1-649',
  },
  {code: 'TD', label: 'Chad', phone: '+235'},
  {
    code: 'TF',
    label: 'French Southern Territories',
    phone: '+262',
  },
  {code: 'TG', label: 'Togo', phone: '+228'},
  {code: 'TH', label: 'Thailand', phone: '+66'},
  {code: 'TJ', label: 'Tajikistan', phone: '+992'},
  {code: 'TK', label: 'Tokelau', phone: '+690'},
  {code: 'TL', label: 'Timor-Leste', phone: '+670'},
  {code: 'TM', label: 'Turkmenistan', phone: '+993'},
  {code: 'TN', label: 'Tunisia', phone: '+216'},
  {code: 'TO', label: 'Tonga', phone: '+676'},
  {code: 'TR', label: 'Turkey', phone: '+90'},
  {
    code: 'TT',
    label: 'Trinidad and Tobago',
    phone: '+1-868',
  },
  {code: 'TV', label: 'Tuvalu', phone: '+688'},
  {
    code: 'TW',
    label: 'Taiwan, Republic of China',
    phone: '+886',
  },
  {
    code: 'TZ',
    label: 'United Republic of Tanzania',
    phone: '+255',
  },
  {code: 'UA', label: 'Ukraine', phone: '+380'},
  {code: 'UG', label: 'Uganda', phone: '+256'},
  {code: 'UY', label: 'Uruguay', phone: '+598'},
  {code: 'UZ', label: 'Uzbekistan', phone: '+998'},
  {
    code: 'VA',
    label: 'Holy See (Vatican City State)',
    phone: '+379',
  },
  {
    code: 'VC',
    label: 'Saint Vincent and the Grenadines',
    phone: '+1-784',
  },
  {code: 'VE', label: 'Venezuela', phone: '+58'},
  {
    code: 'VG',
    label: 'British Virgin Islands',
    phone: '+1-284',
  },
  {
    code: 'VI',
    label: 'US Virgin Islands',
    phone: '+1-340',
  },
  {code: 'VN', label: 'Vietnam', phone: '+84'},
  {code: 'VU', label: 'Vanuatu', phone: '+678'},
  {code: 'WF', label: 'Wallis and Futuna', phone: '+681'},
  {code: 'WS', label: 'Samoa', phone: '+685'},
  {code: 'XK', label: 'Kosovo', phone: '+383'},
  {code: 'YE', label: 'Yemen', phone: '+967'},
  {code: 'YT', label: 'Mayotte', phone: '+262'},
  {code: 'ZA', label: 'South Africa', phone: '+27'},
  {code: 'ZM', label: 'Zambia', phone: '+260'},
  {code: 'ZW', label: 'Zimbabwe', phone: '+263'},
];

/**
 * Gets the user's dial code from their timezone and locale OS information
 * @return {String} Return dial code with a '+' prefix
 */
export default function getUserCountryDialCode() {
  try {
    if (Intl) {
      const userTimeZone = getUserTimeZone();
      const tzArr = userTimeZone.split('/');
      const userCity = tzArr[tzArr.length - 1];
      const userCountryCode = TZCITY_TO_COUNTRYCODE[userCity];
      const userCountryDialCode = PHONE_COUNTRY_CODES[userCountryCode];
      if (!userCountryDialCode) {
        return '';
      }
      return userCountryDialCode;
    }
  } catch {
    console.error('Failed to find user\'s dial code');
  }
  return '';
};

/**
 * Gets the user's country code from their timezone and locale OS information
 * @return {Object} Return country data {code, label, counutryDial}
 */
export function getUserCountry() {
  try {
    if (Intl) {
      const userTimeZone = getUserTimeZone();
      const tzArr = userTimeZone.split('/');
      const userCity = tzArr[tzArr.length - 1];
      const userCountryCode = TZCITY_TO_COUNTRYCODE[userCity];
      const userCountryData = COUNTRY_DATA.find((x) => x.code === userCountryCode);
      if (!userCountryCode || !userCountryData) {
        return null;
      }
      return userCountryData;
    }
  } catch {
    console.error('Failed to find user\'s country code');
  }
  return null;
};

